<div>
    <h2>{{'mantenimientoCultivos.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-error':showError}">
            <h3>{{'mantenimientoCultivos.filters.filtrosFinca' | translate}}</h3>
            <!-- Filtros Finca -->
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}}</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [disabled]="disabledPais" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.provincia' | translate}}</label>
                <app-filterable-list [itemsList]="provincias" [selectedItem]="filtersForm.get('provincia')" [disabled]="disabledProvincia" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.municipio' | translate}}</label>
                <app-filterable-list [itemsList]="municipios" [selectedItem]="filtersForm.get('municipio')" [disabled]="disabledMunicipio" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'global.finca' | translate}}</label>
              <input type="text" formControlName="des">
            </div>
            <div *ngIf= "role === 'Administrador'" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
              <checkbox [id]="'visible'" [initialStatus]="''" [initialRefresh]="refreshCheckbox_visible" [label]="'mantenimientoCultivos.filters.visible'" (refresh)="this.refreshCheckbox_visible = false" (formValue)="this.filtersForm.get('visible')?.patchValue($event)" (pristine)="pristineCheckbox('visible', $event)"></checkbox>
            </div>
            <div [ngClass]="!this.isSmallScreen ? 'entry-5' : 'entry-3-small'" class="alignment-start-filters">
              <checkbox [id]="'fincaDePrueba'" [initialStatus]="''" [initialRefresh]="refreshCheckbox_fincaDePrueba" [label]="'mantenimientoCultivos.filters.fincaPrueba'" (refresh)="this.refreshCheckbox_fincaDePrueba = false" (formValue)="this.filtersForm.get('fincaDePrueba')?.patchValue($event)" (pristine)="pristineCheckbox('fincaDePrueba', $event)"></checkbox>
            </div>
            <div [ngClass]="!this.isSmallScreen ? 'entry-5' : 'entry-3-small'" class="alignment-start-filters">
              <checkbox [id]="'fincaCultivoCH'" [initialStatus]="''" [initialRefresh]="refreshCheckbox_fincaCultivoCH" [label]="'mantenimientoCultivos.filters.cultivoCampanya'" (refresh)="this.refreshCheckbox_fincaCultivoCH = false" (formValue)="this.filtersForm.get('fincaCultivoCH')?.patchValue($event)" (pristine)="pristineCheckbox('fincaCultivoCH', $event)"></checkbox>
            </div>
            <div [ngClass]="!this.isSmallScreen ? 'entry-5' : 'entry-3-small'" class="alignment-start-filters">
              <checkbox [id]="'fincaDesignacionCH'" [initialStatus]="''" [initialRefresh]="refreshCheckbox_fincaDesignacionCH" [label]="'mantenimientoCultivos.filters.fincaCampanya'" (refresh)="this.refreshCheckbox_fincaDesignacionCH = false" (formValue)="this.filtersForm.get('fincaDesignacionCH')?.patchValue($event)" (pristine)="pristineCheckbox('fincaDesignacionCH', $event)"></checkbox>
            </div>
            <div [ngClass]="!this.isSmallScreen ? 'entry-5' : 'entry-3-small'" class="calendar">
              <label>{{'global.fecha.inicio' | translate}}</label>
              <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
              <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="!this.isSmallScreen ? 'entry-5' : 'entry-3-small'" class="calendar">
              <label>{{'global.fecha.fin' | translate}}</label>
              <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
              <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="!this.isSmallScreen ? 'entry-5' : 'entry-3-small'" class="radio-group no-margin-left">
              <input type="radio" id="insercion" value="false" formControlName="dateType">
              <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
              <input type="radio" id="actualizacion" value="true" formControlName="dateType">
              <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>

            <!-- Filtros Cultivo -->
            <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
            <h3>{{'mantenimientoCultivos.filters.filtrosCultivo' | translate}}</h3>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.denominacion' | translate}}</label>
              <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')" [disabled]="disabledDenominacion" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.campanya' | translate}}</label>
              <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')" [disabled]="disabledCampanya" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.productor' | translate}}</label>
              <input type="text" formControlName="desProductor">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.plantasMin' | translate}}</label>
              <input type="number" formControlName="nPlantasMin">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.plantasMax' | translate}}</label>
              <input type="number" formControlName="nPlantasMax">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.aforoMin' | translate}}</label>
              <input type="number" formControlName="aforoMin">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.aforoMax' | translate}}</label>
              <input type="number" formControlName="aforoMax">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.superficieMin' | translate}}</label>
              <input type="number" formControlName="superficieMin">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.superficieMax' | translate}}</label>
              <input type="number" formControlName="superficieMax">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.alturaMin' | translate}}</label>
              <input type="number" formControlName="alturaNivelMarMin">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.alturaMax' | translate}}</label>
              <input type="number" formControlName="alturaNivelMarMax">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.filters.nLicencia' | translate}}</label>
              <input type="text" formControlName="nLicencia">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" *ngIf="showCatastro()">
              <label>{{'mantenimientoCultivos.filters.poligono' | translate}}</label>
              <input type="text" formControlName="poligonoCatastro">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" *ngIf="showCatastro()">
              <label>{{'mantenimientoCultivos.filters.parecela' | translate}}</label>
              <input type="text" formControlName="parcelaCatastro">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
              <label>{{'global.fecha.inicio' | translate}}</label>
              <input [matDatepicker]="fechaInicioCultivos" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicioCultivos" (click)="fechaInicioCultivos.open()">
              <mat-datepicker #fechaInicioCultivos></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
              <label>{{'global.fecha.fin' | translate}}</label>
              <input [matDatepicker]="fechaFinCultivos" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFinCultivos" (click)="fechaFinCultivos.open()">
              <mat-datepicker #fechaFinCultivos></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left">
              <input type="radio" id="insercionCultivos" value="false" formControlName="dateTypeCultivos">
              <label for="insercionCultivos">{{'global.fecha.insercion' | translate}}</label>
              <input type="radio" id="actualizacionCultivos" value="true" formControlName="dateTypeCultivos">
              <label for="actualizacionCultivos">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
              <checkbox [id]="'tieneGeometria'" [initialStatus]="''"  [initialRefresh]="refreshCheckbox_tieneGeometria" [label]="'mantenimientoCultivos.filters.tieneGeometria'" (refresh)="this.refreshCheckbox_tieneGeometria = false" (formValue)="this.filtersForm.get('tieneGeometria')?.patchValue($event)" (pristine)="pristineCheckbox('tieneGeometria', $event)"></checkbox>
            </div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
          title="{{'global.filtros.abrir' | translate}}">
          <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
          (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
          <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
          [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
          title="{{'global.filtros.limpiar' | translate}}">
          <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
          title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
          <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons" *ngIf="this.role === 'Administrador' || this.claims.includes('D_INC_Export')">
      <!-- Icono importación CSV. svg para aplicar tema custom -->
      <svg 
        *ngIf="this.role !== 'Administrador' && !this.claims.includes('FIN_Ins')" class="csv-upload disabled" 
        [attr.title]="'titles.importarCSV' | translate"
        xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 384 512">
          <path d="M177.5,115.9v94.9c0,13.1,10.8,23.7,24.1,23.7h96.3v213.4c0,26.2-21.6,47.4-48.2,47.4H57.2c-26.6,0-48.2-21.3-48.2-47.4V163.3c0-26.2,21.6-47.4,48.2-47.4h120.4ZM69.2,281.9c-16.6,0-30.1,13.3-30.1,29.6v59.3c0,16.4,13.5,29.6,30.1,29.6h12c16.6,0,30.1-13.3,30.1-29.6v-5.9c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v5.9c0,3.3-2.7,5.9-6,5.9h-12c-3.3,0-6-2.7-6-5.9v-59.3c0-3.3,2.7-5.9,6-5.9h12c3.3,0,6,2.7,6,5.9v5.9c0,6.5,5.4,11.9,12,11.9s12-5.3,12-11.9v-5.9c0-16.4-13.5-29.6-30.1-29.6h-12ZM141,346.1l19.1,10.7c3.3,1.9,5.4,5.5,5.4,9.3,0,5.9-4.8,10.7-10.8,10.7h-19.3c-6.6,0-12,5.3-12,11.9s5.4,11.9,12,11.9h19.3c19.3,0,34.9-15.4,34.9-34.4s-6.7-23.7-17.6-29.8l-19.1-10.7c-3.3-1.9-5.4-5.5-5.4-9.3,0-5.9,4.8-10.7,10.8-10.7h13.2c6.6,0,12-5.3,12-11.9s-5.4-11.9-12-11.9h-13.2c-19.3,0-34.9,15.4-34.9,34.4s6.7,23.7,17.6,29.8ZM219.7,293.8c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v23.4c0,25.7,7.7,50.9,22.3,72.3l3.8,5.7c2.3,3.3,5.9,5.3,10,5.3s7.7-2,10-5.3l3.8-5.7c14.5-21.4,22.3-46.6,22.3-72.3v-23.4c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v23.4c0,17-4.1,33.8-12,48.8-7.9-15-12-31.8-12-48.8v-23.4ZM201.6,115.9l96.3,94.9h-96.3v-94.9Z"/>
          <path d="M374.6,104.8l-47.9-53.9-47.9,53.9c-.9,1.1,0,2.7,1.3,2.7h26.1v73.4c0,5.4,4.4,9.8,9.8,9.8h21.2c5.4,0,9.8-4.4,9.8-9.8v-73.4h26.1c1.4,0,2.2-1.6,1.3-2.7Z"/>
      </svg>
      <svg 
        *ngIf="this.role === 'Administrador' || this.claims.includes('FIN_Ins')" class="csv-upload" 
        [attr.title]="'titles.importarCSV' | translate" (click)="showCsvImportModal()"
        xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 384 512">
          <path d="M177.5,115.9v94.9c0,13.1,10.8,23.7,24.1,23.7h96.3v213.4c0,26.2-21.6,47.4-48.2,47.4H57.2c-26.6,0-48.2-21.3-48.2-47.4V163.3c0-26.2,21.6-47.4,48.2-47.4h120.4ZM69.2,281.9c-16.6,0-30.1,13.3-30.1,29.6v59.3c0,16.4,13.5,29.6,30.1,29.6h12c16.6,0,30.1-13.3,30.1-29.6v-5.9c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v5.9c0,3.3-2.7,5.9-6,5.9h-12c-3.3,0-6-2.7-6-5.9v-59.3c0-3.3,2.7-5.9,6-5.9h12c3.3,0,6,2.7,6,5.9v5.9c0,6.5,5.4,11.9,12,11.9s12-5.3,12-11.9v-5.9c0-16.4-13.5-29.6-30.1-29.6h-12ZM141,346.1l19.1,10.7c3.3,1.9,5.4,5.5,5.4,9.3,0,5.9-4.8,10.7-10.8,10.7h-19.3c-6.6,0-12,5.3-12,11.9s5.4,11.9,12,11.9h19.3c19.3,0,34.9-15.4,34.9-34.4s-6.7-23.7-17.6-29.8l-19.1-10.7c-3.3-1.9-5.4-5.5-5.4-9.3,0-5.9,4.8-10.7,10.8-10.7h13.2c6.6,0,12-5.3,12-11.9s-5.4-11.9-12-11.9h-13.2c-19.3,0-34.9,15.4-34.9,34.4s6.7,23.7,17.6,29.8ZM219.7,293.8c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v23.4c0,25.7,7.7,50.9,22.3,72.3l3.8,5.7c2.3,3.3,5.9,5.3,10,5.3s7.7-2,10-5.3l3.8-5.7c14.5-21.4,22.3-46.6,22.3-72.3v-23.4c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v23.4c0,17-4.1,33.8-12,48.8-7.9-15-12-31.8-12-48.8v-23.4ZM201.6,115.9l96.3,94.9h-96.3v-94.9Z"/>
          <path d="M374.6,104.8l-47.9-53.9-47.9,53.9c-.9,1.1,0,2.7,1.3,2.7h26.1v73.4c0,5.4,4.4,9.8,9.8,9.8h21.2c5.4,0,9.8-4.4,9.8-9.8v-73.4h26.1c1.4,0,2.2-1.6,1.3-2.7Z"/>
      </svg>
      <i class="fas fa-file-pdf" [ngClass]="{'disabled': !fincasList || fincasList.length < 1}"
        (click)="exportModal = 1" title="{{'mantenimientoCultivos.exportarA' | translate}} PDF"></i>
      <i class="fas fa-file-csv" [ngClass]="{'disabled': !fincasList || fincasList.length < 1}"
        (click)="exportModal = 3" title="{{'mantenimientoCultivos.exportarA' | translate}} CSV"></i>
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <content class="tabs">
      <form>
      <h3>{{'mantenimientoCultivos.datosCultivos.titulo' | translate}}</h3>
      <section class="info-framed" *ngIf="totalesFincas">
          <div [ngClass]="this.isSmallScreen ? 'entry-5-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.datosCultivos.superficie' | translate}}</label>
              <span>{{totalesFincas.superficie ? (totalesFincas.superficie | number : '1.2-2' : defaultLanguage) : 0}}</span>
          </div>
          <div [ngClass]="this.isSmallScreen ? 'entry-5-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.datosCultivos.nPlantas' | translate}}</label>
              <span>{{totalesFincas.nPlantas ? (totalesFincas.nPlantas | number : '' : defaultLanguage) : 0}}</span>
          </div>
          <div [ngClass]="this.isSmallScreen ? 'entry-5-small' : 'entry-5'">
              <label>{{'mantenimientoCultivos.datosCultivos.aforo' | translate}}</label>
              <span>{{totalesFincas.aforo ? (totalesFincas.aforo | number : '1.2-2' : defaultLanguage) : 0}}</span>
          </div>
          <div [ngClass]="this.isSmallScreen ? 'entry-5-small' : 'entry-5'">
            <label>{{'mantenimientoCultivos.datosCultivos.designado' | translate}}</label>
            <span>{{totalesFincas.kgDesignados ? (totalesFincas.kgDesignados | number : '1.2-2' : defaultLanguage) : 0}}</span>
          </div>
          <div [ngClass]="this.isSmallScreen ? 'entry-5-small' : 'entry-5'">
            <label>{{'mantenimientoCultivos.datosCultivos.porcDesignado' | translate}}</label>
            <span>{{totalesFincas.porcentajeDesignado ? (totalesFincas.porcentajeDesignado | number : '1.2-2' : defaultLanguage) : 0}} %</span>
          </div>
      </section>
      <section class="info-framed" *ngIf="!totalesFincas">
        <div [ngClass]="this.isSmallScreen ? 'entry-5-small' : 'entry-5'">
            <label>{{'mantenimientoCultivos.datosCultivos.calculandoTotales' | translate}}</label>
        </div>
      </section>
    </form>
    <div class="table-wrapper m-bottom">
      <div class="table-container">
        <table>
          <thead>
              <tr>
                  <th></th>
                  <th></th>
                  <th class="id sortable" (click)="toOrderBy('x=> x.id', 1)">
                    {{'mantenimientoCultivos.table.id' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.id', 1)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.municipio.provincia.pais.PaisIdiomas.Where(y=>y.IdiomaId == ' + this.idiomaId + ').FirstOrDefault().DesPais ?? x.municipio.provincia.pais.DesPaisDefecto', 2)">
                    {{'global.pais' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.municipio.provincia.pais.PaisIdiomas.Where(y=>y.IdiomaId == ' + this.idiomaId + ').FirstOrDefault().DesPais ?? x.municipio.provincia.pais.DesPaisDefecto', 2)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.municipio.provincia.des', 3)">
                    {{'global.provincia' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.municipio.provincia.des', 3)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.municipio.des', 4)">
                    {{'global.municipio' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.municipio.des', 4)"></i>
                    </div>
                  </th>
                  <th class="string sortable sortable-biggest" (click)="toOrderBy('x=> x.des', 5)">
                    {{'global.finca' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.des', 5)"></i>
                    </div>
                  </th>
                  <th class="date sortable" (click)="toOrderBy('x=> x.fechaIns', 6)">
                    {{'global.fecha.insercionShort' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.fechaIns', 6)"></i>
                    </div>
                  </th>
                  <th class="date sortable" (click)="toOrderBy('x=> x.fechaUpd', 7)">
                    {{'global.fecha.actualizacionShort' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.fechaUpd', 7)"></i>
                    </div>
                  </th>
                  <th class="action">
                      <i class="fas fa-plus" *ngIf="this.role === 'Administrador' || this.claims.includes('FIN_Ins')"
                        (click)="create()" title="{{'mantenimientoCultivos.tituloNew' | translate}}"></i>
                  </th>
              </tr>
          </thead>
          <tbody *ngFor="let finca of fincasList; let i=index; trackBy: trackByFincaId">
              <tr>
                  <td>
                    <i *ngIf="(finca.existeRegBlockchainCultivo && this.claims.includes('D_EC_InfoBlockchainVisible')) || (finca.existeRegBlockchainCultivo && this.role === 'Administrador')" class="fas fa-circle-nodes"></i>
                  </td>
                  <td class="icon">
                    <i *ngIf="finca.fincaDePrueba" class="fa-solid fa-house-circle-check" title="{{'titles.fincaDePrueba' | translate}}"></i>
                  </td>
                  <td class="id">{{finca.id}}</td>
                  <td class="string">{{finca.desPaisTraduccion}}</td>
                  <td class="string">{{finca.desProvincia}}</td>
                  <td class="string">{{finca.desMunicipio}}</td>
                  <td class="string-longest">{{finca.des}}</td>
                  <td class="date">{{finca.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                  <td class="date">{{finca.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
                  <td class="multi-actions">
                      <i class="fas fa-stream" *ngIf="this.role === 'Administrador' || this.claims.includes('D_MCV_FincaDet')"
                        app-click-stop-propagation (click)="openTabs(i)" title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                      <i class="fas fa-pencil-alt" *ngIf="this.role === 'Administrador' || this.claims.includes('FIN_Upd')" [ngClass]="{'disabled': !finca.registroEditable}"
                        app-click-stop-propagation (click)="update(finca)" title="{{'titles.editar' | translate}}"></i>
                      <i class="far fa-trash-alt" *ngIf="this.role === 'Administrador' || this.claims.includes('FIN_Del')" [ngClass]="{'disabled': finca.registroEnUso}"
                        app-click-stop-propagation (click)="askDelete(finca)" title="{{'titles.eliminar' | translate}}"></i>
                  </td>
              </tr>
              <tr *ngIf="dropdownSection === i">
                  <td colspan="10">
                      <section class="tabs">
                          <ul>
                              <li [ngClass]="{'active': pestanaActiva[i] === 1}" (click)="showCultivos(i)">{{'global.cultivos' | translate}}</li>
                              <li [ngClass]="{'active': pestanaActiva[i] === 2}" (click)="showDesignaciones(i)">{{'mantenimientoCultivos.tabs.designaciones.titulo' | translate}}</li>
                          </ul>
                          <content>
                            <app-cultivo-finca *ngIf="pestanaActiva[i] === 1" [fincaId]="finca.id" [filtersCultivo]="this._filters.filtroCultivo" [desFinca]="finca.des" [paisId]="finca.paisId" (mensaje)="pushMessage($event)"></app-cultivo-finca>
                            <app-designacion-finca *ngIf="pestanaActiva[i] === 2" [fincaId]="finca.id" [filtersCultivo]="this._filters.filtroCultivo" (pushMessage)="pushMessage($event)"></app-designacion-finca>
                          </content>
                      </section>
                  </td>
              </tr>
          </tbody>
          <tfoot *ngIf="!fincasList || (fincasList && fincasList.length < 1)">
              <tr>
                <td colspan="10">
                  {{'global.noContent' | translate}}
                </td>
              </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <app-paginator *ngIf="fincasList && fincasList.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event">
    </app-toast>
  </content>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
      </header>
      <content>
        <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
      </content>
      <footer>
        <button class="secondary" (click)="close()">{{ 'global.cancelar' | translate }}</button>
        <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
      </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
      <header>
        <h4>{{fincaId ? ('mantenimientoCultivos.tituloEdit' | translate) : ('mantenimientoCultivos.tituloNew' | translate)}}</h4>
      </header>
      <app-cultivos-new-edit [fincaId]="fincaId" [provinciaMunicipioCambio]="parentProvinciaMunicipioCambio" (refresh)="refresh($event)" (mensaje)="pushMessage($event)" (refreshGeometryModal)="showGeometryModal($event)" (refreshProvinciaMunicipio)="refreshParentProvinciaMunicipio($event)">
      </app-cultivos-new-edit>
    </div>
</div>
<div class="modal" *ngIf="exportModal > 0">
  <div class="modal-content">
    <header>
      <h4>{{'global.modalInformes.titulo' | translate}} {{exportModal === 1 ? 'PDF' : 'CSV'}}</h4>
      <i class="fas fa-times" (click)="exportModal = 0"></i>
    </header>
    <content>
      <button (click)="export(1)">{{'global.modalInformes.general' | translate}}</button>
      <button (click)="export(2)">{{'global.modalInformes.detallado' | translate}}</button>
    </content>
  </div>
</div>
<div class="modal" *ngIf="geometryModal">
  <div class="modal-content">
    <content>
      <p>{{'mantenimientoCultivos.modalGeometria.paragraph1' | translate}}</p>
      <p>{{'mantenimientoCultivos.modalGeometria.paragraph2' | translate}}</p>
      <p>{{'mantenimientoCultivos.modalGeometria.paragraph3' | translate}}</p>
    </content>
    <footer class="bigger-modal">
      <button (click)="continueOrCancelModification('accept')">{{'global.aceptar' | translate}}</button>
      <button class="secondary" (click)="continueOrCancelModification('cancel')">{{'global.cancelar' | translate}}</button>
    </footer>
  </div>
</div>

<div class="modal" *ngIf="csvImportModal">
    <div class="modal-content csv" [ngClass]="getCsvModalClass()">
      <header>
        <h4>{{ 'csv-import.title' | translate }}</h4>
      </header>
      <content class="content">
        <app-csv-import [mainKeyword]="'crops'" (csvStep)="csvStep = $event" (openFormOrRefreshAfterClose)="hideCsvModal($event)"></app-csv-import>
      </content>
    </div>
</div>
